import Immutable from 'immutable';

import {
  INSTITUTION_SET_WHITE_LABEL_LOGO_URL_START,
  INSTITUTION_SET_WHITE_LABEL_LOGO_URL_SUCCESS,
  INSTITUTION_SET_WHITE_LABEL_LOGO_URL_FAILURE,
  INSTITUTION_SET_WHITE_LABEL_LOGO_ENABLED_START,
  INSTITUTION_SET_WHITE_LABEL_LOGO_ENABLED_SUCCESS,
  INSTITUTION_SET_WHITE_LABEL_LOGO_ENABLED_FAILURE,
  INSTITUTION_SET_WHITE_LABEL_ITEM_VISIBILITY_START,
  INSTITUTION_SET_WHITE_LABEL_ITEM_VISIBILITY_SUCCESS,
  INSTITUTION_SET_WHITE_LABEL_ITEM_VISIBILITY_FAILURE,
  INSTITUTION_SET_WHITE_LABEL_VISIBILITY_ROLE_SETTING_START,
  INSTITUTION_SET_WHITE_LABEL_VISIBILITY_ROLE_SETTING_SUCCESS,
  INSTITUTION_SET_WHITE_LABEL_VISIBILITY_ROLE_SETTING_FAILURE,
} from './actions';

const initialState = Immutable.fromJS({});

export const defaultState = Immutable.Map({
  isSaving: false,
  hasSaved: false,
});

/**
 * @param {object} state
 * @param {object} action
 * @returns {object}
 */
export function InstitutionAdmin(state = initialState, action = {}) {
  const savingStartState = {
    isSaving: true,
    hasSaved: false,
  };

  const savingSuccessState = {
    isSaving: false,
    hasSaved: true,
  };

  const savingFailureState = {
    isSaving: false,
    hasSaved: false,
  };

  const savingStart = (keyPath) => {
    return state.mergeIn(keyPath, savingStartState);
  };

  const savingSuccess = (keyPath) => {
    return state.mergeIn(keyPath, savingSuccessState);
  };

  const savingFailure = (keyPath) => {
    return state.mergeIn(keyPath, savingFailureState);
  };

  switch (action.type) {
    case INSTITUTION_SET_WHITE_LABEL_LOGO_URL_START: {
      return savingStart([
        'Institutions',
        action.institutionPath,
        'whiteLabelLogoImageUrl',
      ]);
    }
    case INSTITUTION_SET_WHITE_LABEL_LOGO_URL_SUCCESS: {
      return savingSuccess([
        'Institutions',
        action.portal.name,
        'whiteLabelLogoImageUrl',
      ]);
    }
    case INSTITUTION_SET_WHITE_LABEL_LOGO_URL_FAILURE: {
      return savingFailure([
        'Institutions',
        action.institutionPath,
        'whiteLabelLogoImageUrl',
      ]);
    }
    case INSTITUTION_SET_WHITE_LABEL_LOGO_ENABLED_START: {
      return savingStart([
        'Institutions',
        action.institutionPath,
        'whiteLabelLogoEnabled',
      ]);
    }
    case INSTITUTION_SET_WHITE_LABEL_LOGO_ENABLED_SUCCESS: {
      return savingSuccess([
        'Institutions',
        action.portal.name,
        'whiteLabelLogoEnabled',
      ]);
    }
    case INSTITUTION_SET_WHITE_LABEL_LOGO_ENABLED_FAILURE: {
      return savingFailure([
        'Institutions',
        action.institutionPath,
        'whiteLabelLogoEnabled',
      ]);
    }
    case INSTITUTION_SET_WHITE_LABEL_ITEM_VISIBILITY_START: {
      return savingStart([
        'Institutions',
        action.institutionPath,
        'whiteLabelItemVisibilities',
        action.settingName,
      ]);
    }
    case INSTITUTION_SET_WHITE_LABEL_ITEM_VISIBILITY_SUCCESS: {
      return savingSuccess([
        'Institutions',
        action.portal.name,
        'whiteLabelItemVisibilities',
        action.settingName,
      ]);
    }
    case INSTITUTION_SET_WHITE_LABEL_ITEM_VISIBILITY_FAILURE: {
      return savingFailure([
        'Institutions',
        action.institutionPath,
        'whiteLabelItemVisibilities',
        action.settingName,
      ]);
    }
    case INSTITUTION_SET_WHITE_LABEL_VISIBILITY_ROLE_SETTING_START: {
      return savingStart([
        'Institutions',
        action.institutionPath,
        'whiteLabelItemVisibilityRoleSetting',
      ]);
    }
    case INSTITUTION_SET_WHITE_LABEL_VISIBILITY_ROLE_SETTING_SUCCESS: {
      return savingSuccess([
        'Institutions',
        action.portal.name,
        'whiteLabelItemVisibilityRoleSetting',
      ]);
    }
    case INSTITUTION_SET_WHITE_LABEL_VISIBILITY_ROLE_SETTING_FAILURE: {
      return savingFailure([
        'Institutions',
        action.institutionPath,
        'whiteLabelItemVisibilityRoleSetting',
      ]);
    }
    default: {
      return state;
    }
  }
}
